import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/Validation.css';

function Validation() {
    return (
        <div>
            <div className="espaceHaut"></div>
            <div className='text-center fondParchemin validation'>
                <h1>Validation</h1>
                <p>Vous pensez avoir résolu les mystères de La Clef ?</p>
            </div>

            <div className='d-flex validationLivres'>
                <div className="row">
                    <div className='col-lg-2 col-0'>
                        &nbsp;
                    </div>
                    <div className='col-lg-4 col-md-6 validationLivre1'>
                        <Link to="/fin" className="btn">
                            Résoudre le mystère<br />d'Astolie
                        </Link>
                        <Link to="/fin">
                            <img src="/img/clef-1.webp" alt="La Clef - validation livre 1" />
                        </Link>
                    </div>
                    <div className='col-lg-4 col-md-6 validationLivre2'>
                        <Link to="/fin2" className="btn">
                            Résoudre le mystère<br />d'Est-Rive
                        </Link>
                        <Link to="/fin2">
                            <img src="/img/clef-2.webp" alt="La Clef - validation livre 2" />
                        </Link>
                    </div>

                    <div className='col-lg-2 col-0'>
                        &nbsp;
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Validation;
